/**
 * Best-effort display name from a FINN email local-part — the same convention used
 * elsewhere in this app (e.g. taActionBoard/format.ts) for fields that only carry an
 * email. `submittedBy` is a plain Airtable text field, not a collaborator/linked record,
 * so there is no paired display name to read instead.
 */
export function nameFromEmail(email: string): string {
  if (!email) return 'Unknown';
  return email
    .split('@')[0]
    .split('.')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}

/** Relative age in whole days, for a compact "how long has this been sitting" read. */
export function daysAgo(iso: string | null): string {
  if (!iso) return 'unknown date';
  const days = Math.floor((Date.now() - new Date(iso).getTime()) / 86_400_000);
  if (days <= 0) return 'today';
  if (days === 1) return 'yesterday';
  return `${days} days ago`;
}
